// @ts-nocheck
import { Configuration } from '@greenkub-fronts/shared/interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

export const initUpsellPage = createAsyncThunk(
  'initUpsellPage',
  async (
    data: { projectId: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    /**
     * Fetch des Upsell
     */
    // dispatch(
    //   extra.apiSlice.endpoints.getUpsellByProject.initiate(
    //     {
    //       projectId: data.projectId,
    //     },
    //     { forceRefetch: true }
    //   )
    // );

    /**
     * Fetch de Catalogue
     */
    dispatch(extra.apiSlice.endpoints.getCatalogue.initiate());

    /**
     * Fetch de Project
     */
    const projectQueryResult = await dispatch(
      extra.apiSlice.endpoints.getProjectById.initiate(
        {
          projectId: data.projectId,
        },
        { forceRefetch: true }
      )
    );

    /**
     * Pour chaque configuration, sa version light à présenter en front
     */
    // const bdcLight = [];
    // if (projectQueryResult.status === 'fulfilled') {
    //   projectQueryResult.data.configurations.forEach(
    //     (config: Configuration) => {
    //       const result = dispatch(
    //         extra.apiSlice.endpoints.getConfigurationDifference.initiate({
    //           configId: config.id,
    //           editableConfig: config,
    //         })
    //       );
    //       bdcLight.push(result)
    //     }
    //   );
    // }

    const configurationsPack = projectQueryResult.data.configurations.map(
      (config: Configuration) => {
        return {
          initialConfig: config,
          editableConfig: cloneDeep(config),
        };
      }
    );

    return {
      project: projectQueryResult.data,
      configurationsPack,
    };
  }
);

export default initUpsellPage;
